import getConfig from 'next/config';

/**
 * @param {string} richtext
 * @param {string | undefined} [language]
 * @returns {string}
 */
const parseRichtext = (richtext, language) => {
  const { publicRuntimeConfig } = getConfig();

  if (language && language !== publicRuntimeConfig.defaultLanguage) {
    const updatedText = richtext.replace(
      /href=["'][/]/g,
      `href="/${language}/`,
    );
    return updatedText;
  }

  return richtext;
};

export default parseRichtext;
